import { FC } from "react"
import { useNavigate } from "react-router-dom"
import { ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"

const AddCustomerPageHeader: FC = () => {
  const navigate = useNavigate()

  return (
    <div className="flex items-center gap-4">
      <Button
        variant="outline"
        size="sm"
        onClick={() => navigate(-1)}
        className="flex items-center gap-2"
      >
        <ArrowLeft className="size-4" />
        Back
      </Button>
      <div>
        <h1 className="text-3xl font-bold">Add New Customer</h1>
        <p className="text-muted-foreground">Create a new customer account and assign devices</p>
      </div>
    </div>
  )
}

export default AddCustomerPageHeader
